import { Link } from "react-router-dom";
import { getNeighbors } from "@/config/city-neighbors";

interface NeighborCitiesProps {
  slug: string;
  service?: "persianas" | "toldos" | "mosquiteras";
}

export function NeighborCities({ slug, service = "persianas" }: NeighborCitiesProps) {
  const neighbors = getNeighbors(slug);
  if (neighbors.length === 0) return null;

  const cityName = slug
    .replace(/-/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

  return (
    <section className="my-12 md:my-16">
      <div className="max-w-container mx-auto px-4 md:px-6">
        <h3 className="font-heading font-bold text-xl md:text-2xl text-text-primary mb-3">
          Zonas cercanas a {cityName}
        </h3>
        <p className="font-body text-sm md:text-base text-text-secondary mb-6 max-w-2xl">
          Cubrimos también las localidades vecinas con visita agrupada para
          optimizar costes de desplazamiento.
        </p>
        <div className="flex flex-wrap gap-3">
          {neighbors.map((n) => (
            <Link
              key={n.slug}
              to={`/${service}/${n.slug}`}
              className="inline-flex items-center gap-1.5 px-4 py-2.5 border border-border rounded-pill font-body text-sm text-text-secondary hover:bg-surface-alt hover:text-primary hover:border-primary transition-colors whitespace-nowrap"
            >
              <i className="ri-map-pin-line text-xs" aria-hidden="true"></i>
              {n.label}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}